var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,11.4C116.1,10,1.5,122.2,0,262.1C0.5,371,71.2,467.2,175,500.2c12.8,2.3,17.5-5.4,17.5-12.1 s0-21.6,0-42.6c-71.2,15.1-86.3-33.5-86.3-33.5c-4.7-15.3-14.8-28.3-28.4-36.8c-23.3-15.4,1.9-15.1,1.9-15.1 c16.3,2.2,30.7,11.7,39.1,25.8c15,26.1,48.1,35.3,74.5,20.7c1.3-12.7,7.1-24.6,16.3-33.5c-56.8-6.3-116.4-27.7-116.4-123.8 c-0.5-25.1,8.8-49.4,25.8-67.7c-7.8-21.5-6.9-45.2,2.6-66.1c0,0,21.6-6.8,69.8,25.6c41.9-11.2,86.1-11.2,128,0 c48.9-32.4,69.8-25.6,69.8-25.6c9.4,20.9,10.3,44.6,2.6,66.1c17.5,18,27.2,42.1,27.2,67.3c0,96.3-60,117.5-116.4,123.8 c12.5,12.1,18.9,29.2,17.5,46.5c0,33.5,0,60.5,0,68.7c0,8.1,4.7,14.7,17.5,12.1C440.9,466.7,511.4,370.8,512,262.1 C510.5,122.2,395.9,10,256,11.4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub10);
export default __webpack_public_path__ + "static/media/github_10.9ae7353ecdaaf5bd8ddff5194069c500.svg";
export { ForwardRef as ReactComponent };